import { useQuery } from "@tanstack/react-query";
import { AssujettiApi } from "../assujetti.api";
import { assujettiKeys } from "./assujetti.keys";

export const useAssujettiListQuery = (
  millesime: number,
  siren: string,
  enabled = true
) => {
  return useQuery({
    queryKey: assujettiKeys.byMillesimeAndSiren(millesime, siren),
    queryFn: () => AssujettiApi.list(millesime, siren),
    staleTime: Infinity,
    enabled,
  });
};
